// Module
var code = "<div class=\"form-group form-group-sm\"> <label class=\"control-label\" kform-builder-tooltip=\"Tag the field for use in custom logic.\">Field Tags</label> <tags-input ng-model=\"tags\" on-tag-added=\"addTag($tag)\" on-tag-removed=\"removeTag($tag)\"></tags-input> </div> ";
// Exports
export default code;